import { useTheme } from '../context/useTheme';

export default function Logo({ className = 'h-6 w-auto', alt = 'Kreatives', variant = 'default' }) {
  const { theme } = useTheme();

  const SRC_MAP = {
    default: {
      dark: '/logo-kreativ-dark.png',
      light: '/logo-kreativ-light.png',
    },
    footer: {
      dark: '/logo-kreativ-dark-footer.png',
      light: '/logo-kreativ-light-footer.png',
    },
  };

  const src = (SRC_MAP[variant] || SRC_MAP.default)[theme] || SRC_MAP.default[theme];
  return <img src={src} alt={alt} className={className} />;
}
